import { useState, useEffect } from 'react';

export function useSessionStorageState<T>(
  key: string, 
  defaultValue: T | (() => T)
) {
  const [state, setState] = useState(() => {
    const stored = sessionStorage.getItem(key);
    try {
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}